export default "__VITE_ASSET__DSs2tpEU__"